import { render, staticRenderFns } from "./ModalProduto.vue?vue&type=template&id=449f4eff&scoped=true"
import script from "./ModalProduto.vue?vue&type=script&lang=js"
export * from "./ModalProduto.vue?vue&type=script&lang=js"
import style0 from "./ModalProduto.vue?vue&type=style&index=0&id=449f4eff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f4eff",
  null
  
)

export default component.exports